// extracted by mini-css-extract-plugin
export default {"tooltipWrapper":"monitoring_tooltipWrapper__WNMfv","tooltipContainer":"monitoring_tooltipContainer__O5jIO"};